export default function clock() {
  const interval = 1000;
  /**
   * Wrapper selector for the clock component
   * @type {string}
   */
  const clockWrapperSelector = '.js-clock-component';

  function localDate(locale, timezone) {
    return new Date().toLocaleString(`${locale}`, {
      timeZone: `${timezone}`,
    });
  }

  function localTime(locale, timezone) {
    return new Date().toLocaleTimeString(`${locale}`, {
      timeZone: `${timezone}`,
    });
  }

  function timerAnalog() {
    const h = window.document.querySelector('.clock__arrow--hour');

    if (h) {
      const m = window.document.querySelector('.clock__arrow--minute');
      const s = window.document.querySelector('.clock__arrow--second');

      const wrap = h.closest(clockWrapperSelector);
      const { locale, timezone } = wrap.dataset;

      setInterval(() => {
        const date = new Date(localDate(locale, timezone));
        const hrs = date.getHours();
        const min = date.getMinutes();
        const sec = date.getSeconds();
        const hRotation = 30 * hrs + min / 2;
        const mRotation = 6 * min;
        const sRotation = 6 * sec;

        h.style.transform = `rotate(${hRotation}deg)`;
        m.style.transform = `rotate(${mRotation}deg)`;
        s.style.transform = `rotate(${sRotation}deg)`;
      }, interval);
    }
  }

  function timerDigital() {
    const dates = window.document.querySelectorAll('.js-clock-date');

    dates.forEach((date) => {
      const wrap = date.closest(clockWrapperSelector);
      const { locale, timezone } = wrap.dataset;
      const time = wrap.querySelector('.js-clock-time');
      let previousDate = new Date(localDate(locale, timezone)).toDateString();

      setInterval(() => {
        const currentDate = new Date(localDate(locale, timezone)).toDateString();
        // don't update DOM if date hasn't changed
        if (previousDate !== currentDate) {
          previousDate = currentDate;
          // eslint-disable-next-line no-param-reassign
          date.innerHTML = currentDate;
        }
        time.innerHTML = localTime(locale, timezone);
      }, interval);
    });
  }

  window.document.addEventListener('DOMContentLoaded', () => {
    timerAnalog();
    timerDigital();
  });
}
